var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('Teleport',{attrs:{"to":"#settings-group-header"}},[_c('T',[_vm._v("Меню ресторана")])],1),_c('MenuItemList',{attrs:{"menu_categories":_vm.$store.getters.menu_categories,"modifier_schemes_map":_vm.$store.getters.menu_modifier_schemes_map,"menu_merged_items":_vm.$store.getters.menu_merged_items,"loading":_vm.loading}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }